import axios from "axios";
import swal from "sweetalert"; 
import Swal from 'sweetalert2';

const api_url = "https://8siu8hczc2.execute-api.us-east-1.amazonaws.com/Prod/";

axios.defaults.baseURL = api_url;

export async function get(path) {
  let res;
  await axios
    .get(path)
    .then((response) => {
      res = response.data;
    })
    .catch((error) => {
      res = error.response.data;
      swal("Error", "Ocurrio un error al obtener los datos " + path, "error");
    });
  return res;
}

export async function post(path, data, message, status = false) {
  let res;
  await axios
    .post(path, data)
    .then((response) => {
      res = response.data;
      if (message && !status) {
        Swal.fire({
          title: 'Carga de archivo exitosa',
          text: message,
          icon: 'success',
          confirmButtonColor: '#146284',
          confirmButtonText: 'Aceptar'
        });        
      }else if (!status) {
        swal("Exito", "Se ha creado correctamente", "success");
      }
    })
    .catch((error) => {
      res = error.response.data;
      // swal("Error", "Ha ocurrido un error al crear, es posible que ya exista o que los datos estén incorrectos", "error");
      console.log(error);
    })
    .finally(() => {});
  return res;
}

export async function put(path, data, message, status = false) { 
  let res;
  await axios
    .put(path, data)
    .then((response) => {
      if (!status) {
        swal("Exito", "Actualizado correctamente", "success");
      }
      res = response.data;    
    })
    .catch((error) => {
      res = error.response.data;
      swal("Error", "No se pudo actualizar", "error");
      console.log(error)
    })
    .finally(() => {
    });
  return res;
}

export async function deleteRequest(path, body, alert) {
  var data = JSON.stringify(body);
  let res;

  var config = {
    method: "DELETE",
    url: api_url + path,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    data: data,
  };
  await axios(config)
    .then(function (response) {
      res = response.data;
      if(alert){
        swal("Exito", "Se ha eliminado correctamente", "success", {
          button: "Aceptar",
          timer: 2000,
        });
      }
    })
    .catch(function (error) {
      res = error.response.data;
      if(alert){
        swal("Error", "No se ha podido eliminar", "error", {
          button: "Aceptar",
          timer: 2000,
        });
      }
    });
  return res;
}

export async function deleteRequestV2(path, body, alert) {
  // var data = JSON.stringify(body);
  let res;

  var config = {
    // method: "DELETE",
    // url: api_url + path,
    // headers: {
    //   "Content-Type": "application/json",
    //   "Access-Control-Allow-Origin": "*",
    // },
    data: body,
  };
  await axios.delete
  (path,config)
    .then(function (response) {
      res = response.data;
      if(alert){
        swal("Exito", "Se ha eliminado correctamente", "success", {
          button: "Aceptar",
          timer: 2000,
        });
      }
    })
    .catch(function (error) {
      res = error.response.data;
      if(alert){
        swal("Error", "No se ha podido eliminar", "error", {
          button: "Aceptar",
          timer: 2000,
        });
      }
    });
  return res;
}


export async function deleteCustomPathRequest(path, body) {
  var axios = require("axios");
  //var data = JSON.stringify(body);
  let res;
  
  var config = {
    method: "DELETE",
    url: path,
    //data: data,
  };
  
  await axios(config)
    .then(function (response) {
      res = response.data;
      swal("Exito", "Se ha eliminado correctamente", "success", {
        button: "Aceptar",
        timer: 2000,
      });
    })
    .catch(function (error) {
      res = error;
      swal("Error", "Ocurrió un error al eliminar", "error");
    });
  return res;
}